/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
  heading: string;
  isEmergency?: boolean;
};

export const AccountMenuSection: FC<Props> = ({
  children,
  heading,
  isEmergency = false,
}) => {
  const classes = styles({ isEmergency });

  return (
    <section>
      <h2 css={classes.heading}>{heading}</h2>
      <ul>{children}</ul>
    </section>
  );
};

const styles = ({ isEmergency }: { isEmergency: boolean }) => ({
  heading: css`
    padding: 8px 12px;
    color: #fff;
    font-size: 14px;
    background-color: ${isEmergency ? "#e84a0e" : "#979797"};
  `,
});
